import { createSlice } from "@reduxjs/toolkit";

import { type FirebaseUser } from "../firebase/api";

type Nullable<T> = T | null;

export interface State {
  isLoading: boolean;
  isAdminUser?: boolean;
  isLoggedIn?: boolean;
  user?: Nullable<Partial<FirebaseUser>>;
}

const INITIAL_STATE: State = {
  isLoading: true,
};

const authSlice = createSlice({
  name: "auth",
  initialState: INITIAL_STATE,
  reducers: {
    setCurrentUser(state, { payload }) {
      return {
        ...(state ?? {}),
        isLoading: false,
        isAdminUser: payload.isAdmin as boolean,
        isLoggedIn: true,
        user: payload,
      };
    },
    clearLogin(state) {
      return {
        ...(state ?? {}),
        isLoading: false,
        isAdminUser: false,
        isLoggedIn: false,
        user: null,
      };
    },
  },
});

export const authActions = authSlice.actions;
export const authReducer = authSlice.reducer;
